export const InactiveContactsModal: string = 'InactiveContactsModal';
